import ApiService from "../api/api.service";
import router from "../router";

/*------------------------------------*\
    Action Constants
\*------------------------------------*/
import {
    GET_OPTIONS,
    GET_MONTHS,
    GET_SELECTED_OPTIONS,
    SET_SELECTED_OPTION,
    SET_PARAM_OPTIONS
} from "./actions.type";

/*------------------------------------*\
    Mutation Constants
\*------------------------------------*/
import {
    CLEAR_ERRORS,
    SET_ERROR,
    SET_OPTIONS,
    SET_SELECTED_OPTIONS
} from "./mutations.type";

/*------------------------------------*\
    State
\*------------------------------------*/
const getDefaultState = () => {
    return {
        gotOptions: false,
        options: {
            sports: {
                name: "SPORTS",
                key: 'sports',
                section: 'normal',
                session: 'ScheduleGroupID',
                cols: 12,
                sm: 12,
                class: 'pa-0',
                configurable: false,
                modal: 'LeaguesModal',
                component: "SportBar",
                multiple: false,
                options: [],
            },
            leagues: {
                name: "LEAGUES",
                key: 'leagues',
                section: 'none',
                session: 'ScheduleID',
                cols: 12,
                sm: 12,
                class: 'pa-0',
                configurable: false,
                multiple: false,
                options: [],
            },
            days: {
                name: "DAY",
                key: 'days',
                section: 'bar',
                session: 'DateRangeStart',
                cols: 12,
                sm: 12,
                component: "DateBar",
                multiple: false,
                options: [],
                print: true
            },
            zip: {
                name: "ZIP",
                key: 'zip',
                section: 'normal',
                session: 'ZipCode',
                cols: 6,
                sm: 4,
                md: 2,
                setting: true,
                component: "textfield",
                mask: '#####-####',
                rules: [
                    (v) =>
                    /^0|[0-9]{5}(?:-[0-9]{4})?|null$/.test(
                        v
                    ) || "Please enter valid zip code",
                ]
            },
            bundles: {
                name: "PACKAGE TYPE",
                key: 'bundles',
                section: 'normal',
                session: 'AccountType',
                cols: 12,
                sm: 8,
                md: 5,
                component: "dropdown",
                multiple: false,
                setting: false,
                options: []
            },
            teams: {
                name: "HIGHLIGHT MY TEAMS",
                key: 'teams',
                section: 'none',
                session: 'TeamHighlightEnabled',
                cols: 12,
                sm: 6,
                component: "dropdown",
                configurable: true,
                multiple: false,
                options: [],
            },
            languages: {
                name: "LANGUAGE",
                key: 'languages',
                section: 'normal',
                cols: 12,
                sm: 6,
                md: 5,
                component: "dropdown",
                multiple: false,
                setting: true,
                options: [],
            },
            groups: {
                name: "GROUP BY",
                key: 'groups',
                section: 'normal',
                cols: 6,
                sm: 6,
                md: 4,
                component: "dropdown",
                multiple: false,
                options: []
            },
            replays: {
                name: "REPLAYS",
                key: 'replays',
                section: 'normal',
                cols: 6,
                sm: 6,
                md: 4,
                component: "dropdown",
                multiple: false,
                options: [],
            },
            months: {
                name: "MONTHS",
                key: 'months',
                section: 'schedule',
                component: "buttons",
                multiple: false,
                options: [],
            },
            hours: {
                name: "BUSINESS HOURS",
                key: 'hours',
                section: 'settings',
                component: 'BusinessHours',
                setting: true,
                multipe: false,
                options: [],

            },
            packs: {
                name: "PACKAGE",
                key: 'packs',
                section: 'none',
                session: 'PackageBaseID',
                cols: 12,
                sm: 8,
                md: 6,
                component: "dropdown",
                multiple: false,
                setting: true,
                options: []
            },
            addons: {
                name: "ADDONS",
                key: 'addons',
                section: 'none',
                session: 'P_IDs',
                cols: 12,
                sm: 12,
                component: "addons",
                class: 'pa-0',
                configurable: false,
                multiple: false,
                setting: true,
                options: [],
            },
            sources: {
                name: "SOURCES",
                key: 'sources',
                section: 'none',
                cols: 6,
                sm: 6,
                md: 4,
                component: "dropdown",
                multiple: false,
                commercial: true,
                options: [],
            },
            timezone: {
                name: "TIMEZONE",
                key: 'timezone',
                section: 'none',
                session: 'TimeZone',
                multiple: false,
            }
        },
        screenoptions: {
            leagues: {
                name: "LEAGUES",
                key: 'leagues',
                session: 'ScheduleID',
                component: "LeagueOrder",
                multiple: true,
            },
            replays: {
                name: "REPLAYS",
                key: 'replays',
                component: "dropdown",
                multiple: false,
            },
        },
        selectedOptions: {
            sports: 0,
            days: "",
            zip: "",
            bundles: 15,
            packs: [],
            teams: 0,
            replays: 0,
            languages: 99,
            displays: 0,
            groups: 0,
            timezone: null,
            sources: 1
        },

    }
};

const state = getDefaultState();

/*------------------------------------*\
    Getters
\*------------------------------------*/
const getters = {
    checkGotOptions(state) {
        return state.gotOptions;
    },
    getCurrentOptions(state) {
        return Object.filter(state.options, option => {
            if (option.commercial && state.selectedOptions.bundles < 20) {
                return false;
            }
            return option.section == 'normal';
        });
    },
    getOptionList: (state) => (key) => {
        return state.options[key].options;
    },
    getScreenOptions(state) {
        return state.screenoptions;
    },
    getSettingOptions(state) {
        return Object.filter(state.options, option => option.setting == true);
    },
    getCurrentAdvanced(state) {
        return Object.filter(state.options, option => option.section == 'advanced');
    },
    getCurrentBars(state) {
        return Object.filter(state.options, option => option.section == 'bar');
    },
    getCurrentOptionsBySection: (state) => (key) => {
        return Object.filter(state.options, option => option.section == key);
    },
    getCurrentMonths(state) {
        return Object.filter(state.options, option => option.section == 'schedule');
    },
    getCurrentSelectedOptions: (state) => (type) => {
        return state.selectedOptions[type];
    },
    getIsCommercial(state) {
        return state.selectedOptions.bundles >= 20;
    }
};

/*------------------------------------*\
    Mutations
\*------------------------------------*/
const mutations = {
    [SET_OPTIONS](state, data) {
        for (const property in data) {
            state.options[property].options = data[property];
        }
        state.gotOptions = true;
    },
    [SET_SELECTED_OPTIONS](state, data) {
        var params = "";
        for (const property in data) {
            if (property == "sports" || property == "leagues") {
                if (params != "") {
                    params += "/";
                }

                if (state.options[property].multiple) {
                    params += 'custom';
                } else {
                    params += encodeURIComponent(data[property].slug);
                }
            }
            if (state.options[property].multiple) {
                state.selectedOptions[property] = [data[property].value];
            } else {
                state.selectedOptions[property] = data[property].value;
            }

        }

        if (router.currentRoute.meta && router.currentRoute.meta.reroute) {
            router.replace(`/${params}`);
        }

    }
};

/*------------------------------------*\
    Actions
\*------------------------------------*/
const actions = {
    [GET_OPTIONS](context) {
        /*
        if(context.getters.checkGotOptions) {
            return;
        }
        */
        context.commit(CLEAR_ERRORS);
        return new Promise((resolve, reject) => {
            ApiService.get("/options")
                .then(({
                    data
                }) => {
                    context.commit(CLEAR_ERRORS);
                    context.commit(
                        SET_OPTIONS, data
                    );
                    resolve(data);
                })
                .catch(({
                    response
                }) => {
                    context.commit(
                        SET_ERROR, {
                            target: 'options',
                            message: response.data.error
                        }
                    );
                    reject(response);
                });
        });
    },
    [GET_MONTHS](context, params) {
        context.commit(CLEAR_ERRORS);
        return new Promise((resolve, reject) => {
            ApiService.get("/options/months", params)
                .then(({
                    data
                }) => {
                    context.commit(CLEAR_ERRORS);
                    context.commit(
                        SET_OPTIONS, data
                    );
                    resolve(data);
                })
                .catch(({
                    response
                }) => {
                    context.commit(
                        SET_ERROR, {
                            target: 'options',
                            message: response.data.error
                        }
                    );
                    reject(response);
                });
        });
    },
    [GET_SELECTED_OPTIONS](context) {
        context.commit(CLEAR_ERRORS);
        return new Promise((resolve, reject) => {
            ApiService.get("/options/selected")
                .then(({
                    data
                }) => {
                    context.commit(CLEAR_ERRORS);
                    context.commit(
                        SET_SELECTED_OPTIONS, data
                    );
                    resolve(data);
                })
                .catch(({
                    response
                }) => {
                    context.commit(
                        SET_ERROR, {
                            target: 'options',
                            message: response.data.error
                        }
                    );
                    reject(response);
                });
        });
    },
    [SET_SELECTED_OPTION](context, details) {
        context.commit(CLEAR_ERRORS);
        return new Promise((resolve, reject) => {
            ApiService.post("/options/selected", details)
                .then(({
                    data
                }) => {
                    context.commit(CLEAR_ERRORS);
                    context.commit(
                        SET_SELECTED_OPTIONS, data
                    );
                    resolve(data);
                })
                .catch(({
                    response
                }) => {
                    context.commit(
                        SET_ERROR, {
                            target: 'options',
                            message: response.data.error
                        }
                    );
                    reject(response);
                });
        });
    },
    [SET_PARAM_OPTIONS](context, params) {
        context.commit(CLEAR_ERRORS);
        return new Promise((resolve, reject) => {
            ApiService.post("/options/params", params)
                .then(({
                    data
                }) => {
                    context.commit(CLEAR_ERRORS);
                    // context.commit(
                    //     SET_SELECTED_OPTIONS, data
                    // );
                    resolve(data);
                })
                .catch(({
                    response
                }) => {
                    context.commit(
                        SET_ERROR, {
                            target: 'options',
                            message: response.data.error
                        }
                    );
                    reject(response);
                });
        });
    },
};

export default {
    getters,
    actions,
    mutations,
    state
}
